











































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DeleteResultModel, TimeEntryViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stTimeEntryApi } from '@/services/st-api';
import { TimeEntryStore } from '@/store/time-entry-store';
import { notifyDeletion, notifySuccess } from '@/utlitities/notifications';

@Component({
  components: {},
})
export default class AutoPauseEntry extends Vue {
  @Prop() entry: TimeEntryViewModel | undefined;
}
